baseApp.service('AccountItemService', ['GeneralUtilsService', function(GeneralUtilsService){
    return {
        parseItemData : function(dataItem){
            dataItem.mainPageLink = dataItem.isParent ? "app.accounts" : "app.topology" ;
            dataItem.mainPageParams = { accountId: dataItem.id };
            if (dataItem.currentLifeCycleExpiration){
                dataItem.expireTime = moment(GeneralUtilsService.getTimeInMiliseconds(dataItem.currentLifeCycleExpiration)).calendar();
            }
            dataItem.servicesCount = Object.keys(dataItem.services).length;
        }
    };
}]);
